export enum GTMItemListIdCollection {
  onlineService = "Servizi Online",
  highlight = "In Evidenza",
}
